var _defs, _rect, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-notification_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256
  })))), /*#__PURE__*/React.createElement("g", {
    id: "notification_2",
    "data-name": "notification \\u2013 2",
    clipPath: "url(#clip-notification_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14554",
    "data-name": "Group 14554",
    transform: "translate(16623 20286)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4843",
    "data-name": "Rectangle 4843",
    width: 256,
    height: 256,
    transform: "translate(-16623 -20286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14553",
    "data-name": "Group 14553",
    transform: "translate(-380 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24676",
    "data-name": "Path 24676",
    d: "M303.752,390.766c0-3.491-52.762-6.321-117.847-6.321s-117.846,2.83-117.846,6.321c0,1.724,12.878,3.288,33.758,4.428-8.1,1.143-12.756,2.475-12.756,3.9,0,4.245,41.4,7.686,92.459,7.686s92.458-3.441,92.458-7.686c0-.779-1.4-1.531-3.99-2.239a.849.849,0,0,1,.175-1.667C290.942,394.046,303.752,392.486,303.752,390.766Z",
    transform: "translate(-16301.058 -20465.723)",
    fill: "#d3edf3",
    opacity: 0.217,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24677",
    "data-name": "Path 24677",
    d: "M173.06,174.748h94.045c22.826,0,42.9-10.081,47.979-24.456,2.569-7.272,1.173-15.166-9.312-22.176-29.6-19.792,2.574-22.344-9.01-46.283C284.877,57.272,230.706,39.4,169.253,53.65,77.244,74.987,84.6,177.611,173.06,174.748Z",
    transform: "translate(-16322.698 -20258.186)",
    fill: "#d3edf3",
    opacity: 0.24,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24678",
    "data-name": "Path 24678",
    d: "M211.739,215.6h74.749c18.143,0,34.1-8.013,38.134-19.438,2.042-5.78.932-12.054-7.4-17.626-23.53-15.731,2.046-17.76-7.162-36.787-9.446-19.52-52.5-33.726-101.347-22.4C135.582,136.313,141.428,217.88,211.739,215.6Z",
    transform: "translate(-16355.108 -20299.031)",
    fill: "#a7dbe7",
    opacity: 0.182,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24680",
    "data-name": "Path 24680",
    d: "M223.015,87.549s-1.3-7.23,1.42-7.4,2.366,4.59,3.549,3.572-.592-10.365,3.9-11.075,1.893,11.739,3.431,11.075.946-4.687,3.668-4.273,1.538,4.969,2.9,6.271c1.225,1.171,3.039.931,3.49-.769,1.005-3.786,4.436-3.436,4.969,0,.3,1.96.473,2.6.473,2.6",
    transform: "translate(-16395.699 -20272.893)",
    fill: "#3aadca",
    opacity: 0.247
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24682",
    "data-name": "Path 24682",
    d: "M602,163.887s-1.348-7.175,1.471-7.349,2.452,4.756,3.677,3.7-.613-10.739,4.045-11.474,1.961,12.162,3.555,11.474.981-4.856,3.8-4.427,1.594,5.149,3,6.5c1.269,1.214,3.148.964,3.616-.8,1.042-3.922,4.6-3.559,5.148,0,.315,2.031.49,2.691.49,2.691L602,163.887",
    transform: "translate(-16705.656 -20370.473)",
    fill: "#3aadca",
    opacity: 0.247
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24683",
    "data-name": "Path 24683",
    d: "M84.769,238.609a4.117,4.117,0,1,1-4.115,4.115A4.121,4.121,0,0,1,84.769,238.609Zm2.581,4.115a2.579,2.579,0,1,0-2.581,2.581A2.58,2.58,0,0,0,87.35,242.724Z",
    transform: "translate(-16123.491 -20425.07)",
    fill: "#7cc8dc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24684",
    "data-name": "Path 24684",
    d: "M175.541,213.746a2.659,2.659,0,1,1-2.658,2.658A2.661,2.661,0,0,1,175.541,213.746Zm1.666,2.658a1.665,1.665,0,1,0-1.666,1.666A1.666,1.666,0,0,0,177.207,216.4Z",
    transform: "translate(-16381.694 -20324.598)",
    fill: "#7cc8dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14551",
    "data-name": "Group 14551",
    transform: "translate(-16219.695 -20213.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25082",
    "data-name": "Path 25082",
    d: "M133.086,94.448c-3.931-4.811-6.706-7.26-6.706-20.525,0-12.147-6.2-16.474-11.308-18.576a2.727,2.727,0,0,1-1.523-1.615c-.9-3.048-3.406-5.733-6.743-5.733s-5.849,2.687-6.735,5.736a2.7,2.7,0,0,1-1.523,1.612c-5.111,2.1-11.308,6.417-11.308,18.576-.008,13.264-2.783,15.713-6.714,20.525a3.087,3.087,0,0,0,2.647,4.986h47.283A3.088,3.088,0,0,0,133.086,94.448Z",
    fill: "none",
    stroke: "#3aadca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25083",
    "data-name": "Path 25083",
    d: "M211.594,384v2.449a9.8,9.8,0,0,1-19.594,0V384",
    transform: "translate(-94.992 -284.566)",
    fill: "none",
    stroke: "#3aadca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14552",
    "data-name": "Group 14552",
    transform: "translate(-120.442 2.618)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_764",
    "data-name": "Ellipse 764",
    cx: 9.513,
    cy: 9.513,
    r: 9.513,
    transform: "translate(-15989 -20176)",
    fill: "#1d839d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(-15982.214 -20163.213)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.10645b62e73670e3cb19441c9ef3abfb.svg";
export { ForwardRef as ReactComponent };